import {
  SearchFilterConfig,
  HasTenantResource,
  ResourceConfig,
  RailsUpdateTrackingResource
} from "@hidat/huijs-resource";
import {FieldConfig, FieldDataTypes, ModelInterface, Uuid} from "@hidat/huijs-common";
import {RblResourceInterface} from "../rbl-resource.interface";

export const ReleaseNameConfig = new ResourceConfig('ReleaseName', 'releases', true, true)
  .setVocabCode('RELEASE')
  .addFields([
    new FieldConfig('name'),
    new FieldConfig('artistName'),
    new FieldConfig('releaseYear'),
    new FieldConfig('collectionTitleId', FieldDataTypes.INTEGER),
    new FieldConfig('trackCount', FieldDataTypes.INTEGER),
  ])
  .setSorts({
    name: "name",
    artistname: {
      dbName: 'artistName',
      secondarySort: {
        dbName: 'name'
      }
    }
  })
  .setDefaultSort('name')

export interface ReleaseNameInterface extends ModelInterface, RailsUpdateTrackingResource, HasTenantResource {
  id: Uuid | undefined;
  name: string | undefined;
  artistName: string | undefined;
  releaseYear: string | undefined;
  collectionTitleId: number | undefined;
  trackCount: number | undefined;
}

export const ReleaseNameFilterConfig = new SearchFilterConfig(ReleaseNameConfig, {only:[
  'name',
  'artistName',
]});
